module.exports = require('./helpers/bundle-url').getBundleURL('gR264') + "AdobeExperienceCloud.bfdb429e.svg";